import { ToastManagerStore } from "@core/presentacion/component/feedback/toast-manager/toast-manager.store";
import { IndicatorRepository } from "@project/data/repositories/technical-proposal/indicator.repository";
import { IndicatorComment } from "@project/domain/models/technical-proposals.model";
import { inject, injectable } from "inversify";

@injectable()
export class GetIndicatorCommentsUseCase {
    constructor(
        @inject(IndicatorRepository)
        private readonly indicatorRepository: IndicatorRepository,
    ) {}

    async execute(indicatorId: number): Promise<IndicatorComment[]> {
        const commentsResult =
            await this.indicatorRepository.getComments(indicatorId);

        if (commentsResult.isLeft()) {
            ToastManagerStore.error(commentsResult.getLeftOrThrow().message);
        }

        return commentsResult.fold(
            () => [],
            (comments) => comments,
        );
    }
}
